import { IS_BROWSER } from 'redux-bundler'

const defaults = {
  enabled: true,
  url: '/sw.js'
}

export default spec => {
  const opts = Object.assign({}, defaults, spec)
  return {
    name: 'sw-manager',
    init: store => {
      if (IS_BROWSER && 'serviceWorker' in window.navigator && opts.enabled) {
        navigator.serviceWorker
          .register(opts.url)
          .then(registration => {
            const currentController = navigator.serviceWorker.controller

            navigator.serviceWorker.addEventListener('controllerchange', () => {
              console.log('page controller changed')
              if (currentController) {
                console.log('existing SW was replaced with another one')
              } else {
                console.log('did not have active SW, but now does')
                // if (!hasNotifiedUserAboutOffline) {
                // notifyUserTheAppWillWorkOffline()
                // }
              }
            })
          })
          .catch(console.error)
      }
    }
  }
}
